export default {
  meta: {
    title: "PixelHaha {'|'} Images libres de droits à télécharger",
    description:
      "Découvrez une grande variété d'images époustouflantes. Des paysages à l'art abstrait, toutes les images sont gratuites et parfaites pour enrichir vos idées de conception et vos graphiques de médias sociaux.",
    keywords: "gratuit, stock, galerie, texte en image, généré par l'IA",
    searchTitle:
      "PixelHaha {'|'} {number}+ Meilleurs {keyword} · Téléchargement 100% gratuit",
    searchDescription:
      "Téléchargez les images {keyword} parfaites. Trouvez plus de {number}+ des meilleures images {keyword} gratuites. Gratuit pour une utilisation commerciale Aucune attribution requise Sans droits d'auteur.",
    404: "Erreur 404 - PixelHaha",
  },
};
